import { takeEvery } from 'redux-saga/effects';

// internal
import * as Action from '@app/store/typings/actions/user.d';
import {
  fetchDataSelect,
  fetchMyuser,
  fetchUserInBrand,
  fetchUserInProject,
  fetchCurrentUserInBrand,
  fetchCurrentUserInProject,
  fetchUserInvite,
  fetchUserByName,
} from './fetch';
import { updateUser, updateUserInvite, changePassword, uploadUserPicture } from './update';
import { inviteUserInProject, inviteUserInBrand, inviteUserMember } from './invite';
import { deleteUserAccount } from './delete';

export function* userSaga() {
  yield takeEvery(Action.KEY_USER_SELECT_FETCH, fetchDataSelect);
  yield takeEvery(Action.KEY_USER_FETCH_BY_NAME, fetchUserByName);
  yield takeEvery(Action.KEY_USER_MYUSER_FETCH, fetchMyuser);
  yield takeEvery(Action.KEY_USER_FETCH_INBRAND, fetchUserInBrand);
  yield takeEvery(Action.KEY_USER_FETCH_INPROJECT, fetchUserInProject);
  yield takeEvery(Action.KEY_USER_INBRAND_WITHID, fetchCurrentUserInBrand);
  yield takeEvery(Action.KEY_USER_INPROJECT_WITHID, fetchCurrentUserInProject);
  yield takeEvery(Action.KEY_USER_UPDATE, updateUser);
  yield takeEvery(Action.KEY_USER_INVITE_INPROJECT, inviteUserInProject);
  yield takeEvery(Action.KEY_USER_INVITE_INBRAND, inviteUserInBrand);
  yield takeEvery(Action.KEY_USER_INVITE_FETCH, fetchUserInvite);
  yield takeEvery(Action.KEY_USER_MEMBER_INVITE, inviteUserMember);
  yield takeEvery(Action.KEY_USER_UPDATE_INVITE, updateUserInvite);
  yield takeEvery(Action.KEY_USER_DELETE, deleteUserAccount);
  yield takeEvery(Action.KEY_USER_CHANGE_PASSWORD, changePassword);
  yield takeEvery(Action.KEY_USER_UPLOAD_PICTURE, uploadUserPicture);
}
